export { default } from "./SlidingPanel";
